<template>
  <div style="margin:1%">
    <b-row align-v="end" align-h="start">
      <b-col xl="2" md="3" cols="4">
        <b-row>
          <b-col>
            <md-button @click.stop="showSelectService" class="md-raised">{{ $t('Add') }}</md-button>
          </b-col>
          <b-col v-if="seviceLinks.length > 0">
            <md-button @click.stop="showTransferSerivces" class="md-raised">{{ $t('Transfer') }}</md-button>
          </b-col>
        </b-row>
      </b-col>
      <b-col xl="2" md="4" cols="4">
        <md-field>
          <label for="curCustomers">{{$t('Select account')}}</label>
          <md-select v-model="selectedAccount">
            <md-option v-for="item in currentRow.accounts" :key="item" :value="item"> {{ item }} </md-option>
          </md-select>
        </md-field>
      </b-col>
    </b-row>

    <basic-table
      v-if="seviceLinks"
      :items="seviceLinks"
      :fields="serviceLinksFields"
      :perPage="perPageServiceLinks"
      :currentPage="currentPageServiceLinks"
      @ClickOnEditButton="ClickOnEditServiceButton"
      @ClickOnDeleteButton="ClickOnDeleteServiceButton"
      isDelete="true"
      isEdit="true"/>
      <table-manager-bottom
          :totalRows="seviceLinks.length" :perPage="perPageServiceLinks"
          v-model="currentPageServiceLinks"/>

    <b-modal ref="modalSelectService" hide-footer hide-header :title="$t('Select service')" size="xl">
      <b-row align-v="end">
        <b-col>
        <md-field>
          <label>{{$t('Type to Search')}}</label>
          <md-input v-model="filter" @update="filterChanged"></md-input>
        </md-field>
        </b-col>
        <b-col>
          <b-form-group label-align="right" :label="$t('Service type')" label-cols="4" label-cols-xl="4" label-cols-md="4" style="margin-bottom:0.2rem">
            <b-form-select v-model="selectedServiceType" :options="servicesTypeList" />
          </b-form-group>
        </b-col>
      </b-row>

      <basic-table
          v-if="selectService"
          :items="selectService"
          :fields="selectServiceFields"
          @RowSelected="rowClickHandler"
          @ClickOnEditButton="selectServiceDblClickHandler"
          :perPage="perPage"
          :currentPage="currentPageService"
          :disableSettings="true"
          :isDelete="false"
          :isEdit="false"/>
      <table-manager-bottom
          v-if="selectService"
          :totalRows="selectService.length" :perPage="perPage"
          v-model="currentPageService"/>

      <modal-ok-cancel @save="formSelectService" @cancel="hideSelectService" saveButtonLabel="Ok"  size="lg"/>
    </b-modal>

    <b-modal hide-footer ref="modalOneTime" :title="$t('One-time service link')" @hidden="isShowOneTime = false">
      <FormOneTime v-if="isShowOneTime"
      @hideSelectService="hideSelectService"
      :currentUser="currentRow"
      :currentService="currentRowService"
      :selectedAccount="selectedAccount"
      :isEdit="isEdit"/>
    </b-modal>
    <b-modal hide-footer ref="modalPeriodic" :title="$t('Periodic service link')" @hidden="isShowPeriodic = false" size="lg">
      <FormPeriodic v-if="isShowPeriodic"
      :listOfCoefficientScheme="listOfCoefficientScheme"
      :listOfChargePolicy="listOfChargePolicy"
      @hideSelectService="hideSelectService"
      :currentUser="currentRow"
      :currentService="currentRowService"
      :selectedAccount="selectedAccount"
      :isEdit="isEdit"/>
    </b-modal>
    <b-modal hide-footer ref="modalHotspot" :title="$t('Hotspot service link')" @hidden="isShowHotspot = false" size="lg">
      <FormHotspot v-if="isShowHotspot"
      :listOfChargePolicy="listOfChargePolicy"
      @hideSelectService="hideSelectService"
      :currentUser="currentRow"
      :currentService="currentRowService"
      :selectedAccount="selectedAccount"
      :isEdit="isEdit"/>
    </b-modal>
    <b-modal hide-footer ref="modalDialup" :title="$t('Dial-up service link')" @hidden="isShowDialup = false" size="lg">
      <FormDialup v-if="isShowDialup"
      :listOfChargePolicy="listOfChargePolicy"
      :listOfCoefficientScheme="listOfCoefficientScheme"
      @hideSelectService="hideSelectService"
      :currentUser="currentRow"
      :currentService="currentRowService"
      :selectedAccount="selectedAccount"
      :isEdit="isEdit"/>
    </b-modal>
    <b-modal hide-footer ref="modalTelephony" :title="$t('Telephony service link')" @hidden="isShowTelephony = false" size="lg">
      <FormTelephony v-if="isShowTelephony"
      :listOfCoefficientScheme="listOfCoefficientScheme"
      :listOfChargePolicy="listOfChargePolicy"
      @hideSelectService="hideSelectService"
      :currentUser="currentRow"
      :currentService="currentRowService"
      :selectedAccount="selectedAccount"
      :isEdit="isEdit"/>
    </b-modal>
    <b-modal hide-footer ref="modalIPTraffic" :title="$t('IP traffic service link')" @hidden="isShowTPTraffic = false" size="lg">
      <FormIPTraffic v-if="isShowTPTraffic"
      :listOfCoefficientScheme="listOfCoefficientScheme"
      :listOfChargePolicy="listOfChargePolicy"
      @hideSelectService="hideSelectService"
      :currentUser="currentRow"
      :currentService="currentRowService"
      :selectedAccount="selectedAccount"
      :isEdit="isEdit"/>
    </b-modal>
    <b-modal hide-footer ref="modalVideo" :title="$t('Video on demand')" @hidden="isShowVideo = false">
      <FormVideo v-if="isShowVideo"
      @hideSelectService="hideSelectService"
      :currentUser="currentRow"
      :currentService="currentRowService"
      :selectedAccount="selectedAccount"
      :isEdit="isEdit"/>
    </b-modal>
    <b-modal hide-footer ref="modalIPTV" :title="$t('IPTV service link')" @hidden="isShowIPTV = false">
      <FormIPTV v-if="isShowIPTV"
      :listOfCoefficientScheme="listOfCoefficientScheme"
      :listOfChargePolicy="listOfChargePolicy"
      @hideSelectService="hideSelectService"
      :currentUser="currentRow"
      :currentService="currentRowService"
      :selectedAccount="selectedAccount"
      :isEdit="isEdit"/>
    </b-modal>
    <b-modal hide-footer ref="modalFreezed" :title="$t('Freezed service link')" @hidden="isShowIPTV = false">
      <FormFreezed v-if="isShowFreezed"
      @hideSelectService="hideSelectService"
      :currentUser="currentRow"
      :currentService="currentRowService"
      :selectedAccount="selectedAccount"
      :isEdit="isEdit"/>
    </b-modal>
    <b-modal :title="$t('Transfer services')" ref="modalTransferServices" id="modalTransferServices" hide-footer>
      <FormTransferServices
      :account_id="selectedAccount"
      @update="reload"
      @close="closeModalTransferServices"/>
    </b-modal>
  </div>
</template>

<script>
import FormTransferServices from './formTransferServices.vue'
import FormOneTime from './formOnce.vue'

import FormPeriodic from './formPeriodic.vue'
import FormHotspot from './formHotspot.vue'
import FormDialup from './formDialup.vue'
import FormTelephony from './formTelephony.vue'
import FormIPTraffic from './formIPTraffic.vue'
import FormVideo from './formVOD.vue'
import FormIPTV from './formIPTV.vue'
import FormFreezed from './formFreezed.vue'
export default {
  components: {
    FormOneTime,
    FormPeriodic,
    FormHotspot,
    FormDialup,
    FormTelephony,
    FormIPTraffic,
    FormVideo,
    FormIPTV,
    FormFreezed,
    FormTransferServices
  },
  props: {
    listOfCoefficientScheme: null,
    listOfChargePolicy: null,
    currentRow: null
  },
  data () {
    return {
      service_policy_id: 0,
      isEdit: false,
      selectedAccount: null,
      isShowOneTime: false,
      isShowPeriodic: false,
      isShowHotspot: false,
      isShowDialup: false,
      isShowTelephony: false,
      isShowTPTraffic: false,
      isShowVideo: false,
      isShowIPTV: false,
      isShowFreezed: false,
      selectServiceFields: [
        { key: 'service_id', label: this.$i18n.t('ID'), sortable: true, thStyle: { width: '4rem' } },
        { key: 'service_name', label: this.$i18n.t('Service name'), sortable: true },
        { key: 'service_type_name', label: this.$i18n.t('Service type'), sortable: true, thStyle: { width: '8rem' } },
        { key: 'cost',
          label: this.$i18n.t('Cost'),
          sortable: true,
          formatter: (val, key, item) => {
            return val.toFixed(2)
          },
          thStyle: { width: '8rem' } },
        { key: 'comment', label: this.$i18n.t('Comment'), sortable: true }
      ],
      serviceLinksFields: [
        { key: 'service_id', label: this.$i18n.t('Service ID'), sortable: true },
        { key: 'service_name', label: this.$i18n.t('Service name'), sortable: true },
        { key: 'house_address',
          label: this.$i18n.t('House'),
          sortable: true,
          formatter: (val, key, item) => {
            if (val === 'House not selected') {
              return this.$t('House not selected')
            }
            return val
          }},
        { key: 'service_type_name', label: this.$i18n.t('Service type'), sortable: true },
        { key: 'cost',
          label: this.$i18n.t('Cost'),
          sortable: true,
          formatter: (val, key, item) => {
            return val.toFixed(2)
          } },
        { key: 'service_link_id', label: this.$i18n.t('Service link ID'), sortable: true },
        { key: 'accounting_period_id', label: this.$i18n.t('Accounting period ID'), sortable: true },
        { key: 'comment', label: this.$i18n.t('Comment'), sortable: true },
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}

      ],
      currentRowServiceLink: null,
      currentRowService: {service_type: 0},
      is_dev: process.env.NODE_ENV === 'development',
      options: {
        isShowAddButton: true,
        isNotSearched: true,
        isNotPerPage: true,
        isAccountSelected: true
      },
      filter: '',
      perPageServiceLinks: 10,
      currentPageServiceLinks: 1,
      perPage: 15,
      totalRows: 0,
      currentPage: 1,
      currentPageService: 1,
      servicesTypeList: [
        {text: this.$i18n.t('All'), value: -1},
        {text: this.$i18n.t('One-time service'), value: 1},
        {text: this.$i18n.t('Periodic service'), value: 2},
        {text: this.$i18n.t('IP traffic service'), value: 3},
        {text: this.$i18n.t('Hotspot service'), value: 4},
        {text: this.$i18n.t('Dial-up service'), value: 5},
        {text: this.$i18n.t('Telephony service'), value: 6},
        {text: this.$i18n.t('IPTV service'), value: 8},
        {text: this.$i18n.t('Video on demand'), value: 9},
        {text: this.$i18n.t('Freezed service'), value: 10}
      ],
      selectedServiceType: -1
    }
  },
  methods: {
    closeModalTransferServices () {
      this.$refs.modalTransferServices.hide()
    },
    selectServiceDblClickHandler (item, index, event) {
      if (this.currentRowService) {
        this.currentRowService._rowVariant = ''
      }
      this.currentRowService = item
      this.$set(this.currentRowService, '_rowVariant', 'info')
      this.formSelectService()
    },
    rowServiceLinkClickHandlerDouble (item, index, event) {
      if (this.currentRowServiceLink) {
        this.currentRowServiceLink._rowVariant = ''
      }
      this.currentRowServiceLink = item
      this.$set(this.currentRowServiceLink, '_rowVariant', 'info')
      this.showEditService()
    },
    async formSelectService () {
      if (!this.currentRowService) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select service'), 'Error')
        return
      }
      if (![1, 10].includes(this.currentRowService.service_type)) {
        this.currentRowService.policy_id = await this.get_service_charge_policy(this.currentRowService.service_id)
      }
      switch (this.currentRowService.service_type) {
        case 1:
          this.showOneTime()
          break
        case 2:
          this.showPeriodic()
          break
        case 3:
          this.showIPTraffic()
          break
        case 4:
          this.showHotspot()
          break
        case 5:
          this.showDialup()
          break
        case 6:
          this.showTelephony()
          break
        case 8:
          this.showIPTV()
          break
        case 9:
          this.showVideo()
          break
        case 10:
          this.showFreezed()
          break
      }
      this.$refs.modalSelectService.hide()
    },
    showTransferSerivces () {
      this.$refs.modalTransferServices.show()
    },
    showEditService (row) {
      if (!this.currentRowServiceLink) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select service'), 'Error')
        return
      }
      this.currentRowService = this.currentRowServiceLink
      if (![1, 10].includes(this.currentRowService.service_type)) {
        this.currentRowService.policy_id = this.get_service_charge_policy(this.currentRowService.service_id)
      }

      switch (this.currentRowService.service_type) {
        case 1:
          this.showOneTimeEdit()
          break
        case 2:
          this.showPeriodicEdit()
          break
        case 3:
          this.showIPTrafficEdit()
          break
        case 4:
          this.showHotspotEdit()
          break
        case 5:
          this.showDialupEdit()
          break
        case 6:
          this.showTelephonyEdit()
          break
        case 8:
          this.showIPTVEdit()
          break
        case 9:
          this.showVideoEdit()
          break
        case 10:
          this.showFreezedEdit()
          break
      }
    },
    showOneTime () {
      this.isEdit = false
      this.isShowOneTime = true
      this.$refs.modalOneTime.show()
    },
    showOneTimeEdit () {
      this.isEdit = true
      this.isShowOneTime = true
      this.$refs.modalOneTime.show()
    },
    showPeriodic () {
      this.isEdit = false
      this.isShowPeriodic = true
      this.$refs.modalPeriodic.show()
    },
    showPeriodicEdit () {
      this.isEdit = true
      this.isShowPeriodic = true
      this.$refs.modalPeriodic.show()
    },
    showHotspot () {
      this.isEdit = false
      this.isShowHotspot = true
      this.$refs.modalHotspot.show()
    },
    showHotspotEdit () {
      this.isEdit = true
      this.isShowHotspot = true
      this.$refs.modalHotspot.show()
    },
    showDialup () {
      this.isEdit = false
      this.isShowDialup = true
      this.$refs.modalDialup.show()
    },
    showDialupEdit () {
      this.isEdit = true
      this.isShowDialup = true
      this.$refs.modalDialup.show()
    },
    showTelephony () {
      this.isEdit = false
      this.isShowTelephony = true
      this.$refs.modalTelephony.show()
    },
    showTelephonyEdit () {
      this.isEdit = true
      this.isShowTelephony = true
      this.$refs.modalTelephony.show()
    },
    showIPTraffic () {
      this.isEdit = false
      this.isShowTPTraffic = true
      this.$refs.modalIPTraffic.show()
    },
    showIPTrafficEdit () {
      this.isEdit = true
      this.isShowTPTraffic = true
      this.$refs.modalIPTraffic.show()
    },
    showVideo () {
      this.isEdit = false
      this.isShowVideo = true
      this.$refs.modalVideo.show()
    },
    showVideoEdit () {
      this.isEdit = true
      this.isShowVideo = true
      this.$refs.modalVideo.show()
    },
    showIPTV () {
      this.isEdit = false
      this.isShowIPTV = true
      this.$refs.modalIPTV.show()
    },
    showIPTVEdit () {
      this.isEdit = true
      this.isShowIPTV = true
      this.$refs.modalIPTV.show()
    },
    showFreezed () {
      this.isEdit = false
      this.isShowFreezed = true
      this.$refs.modalFreezed.show()
    },
    showFreezedEdit () {
      this.isEdit = true
      this.isShowFreezed = true
      this.$refs.modalFreezed.show()
    },
    showSelectService () {
      for (let el of this.selectService) {
        el._rowVariant = ''
      }
      this.currentRowService = null
      this.currentPageService = 1
      this.$refs.modalSelectService.show()
    },
    async get_service_charge_policy (sid) {
      let response = await this.$store.dispatch('Tariffing/GET_SERVICE_CHARGE_POLICY', {service_id: sid}).then(response => { return response })
      if (response.status === 200) {
        return response.data.policy_id
      }
      this.$root.$emit('makeToasts', 'warning', this.$i18n.t('Failed to get charge policy for service, default №1 is used'), 'Warning')
      return 1 // default policy id is 1
    },
    hideSelectService () {
      this.$refs.modalOneTime.hide()
      this.$refs.modalSelectService.hide()
      this.$refs.modalPeriodic.hide()
      this.$refs.modalHotspot.hide()
      this.$refs.modalDialup.hide()
      this.$refs.modalTelephony.hide()
      this.$refs.modalIPTraffic.hide()
      this.$refs.modalVideo.hide()
      this.$refs.modalIPTV.hide()
      this.$refs.modalFreezed.hide()
    },
    ClickOnEditServiceButton (item) {
      this.currentRowServiceLink = item
      this.showEditService()
    },
    ClickOnDeleteServiceButton (item) {
      this.currentRowServiceLink = item
      this.$root.$emit('showConfirmation', 'Confirmation', 'Are you sure you want to delete one of "Service links"?', this.deleteServiceLink)
    },
    async deleteServiceLink () {
      if (this.currentRowServiceLink) {
        if (this.currentRowServiceLink.service_type === 3) {
          let response = await this.$store.dispatch('Tariffing/DELETE_RADIUS_SESSION', this.currentRowServiceLink.service_link_id).then(response => { return response.data })
          if (response.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          }
        }
        let response = await this.$store.dispatch('Users/DELETE_USER_SERVICES_LINKS', this.currentRowServiceLink.service_link_id).then(response => { return response.data })
        if (response.error) {
          this.$root.$emit('makeToasts', 'danger', response.error, 'Error')
        } else {
          this.$root.$emit('makeToasts')
          this.$store.dispatch('Users/GET_USER_SERVICES_LINKS_ACC', this.selectedAccount)
        }
      }
    },
    rowServiceLinkClickHandler (row) {
      if (this.currentRowServiceLink) {
        this.currentRowServiceLink._rowVariant = ''
      }
      this.currentRowServiceLink = row
      this.$set(this.currentRowServiceLink, '_rowVariant', 'info')
    },
    rowClickHandler (row) {
      if (this.currentRowService) {
        this.currentRowService._rowVariant = ''
      }
      this.currentRowService = row
      this.$set(this.currentRowService, '_rowVariant', 'info')
    },
    filterChanged (value) {
      this.filter = value
    },
    reload () {
      this.$store.dispatch('Users/GET_USER_SERVICES_LINKS_ACC', this.selectedAccount)
    }
  },
  watch: {
    selectedAccount: function () {
      this.$store.dispatch('Users/GET_USER_SERVICES_LINKS_ACC', this.selectedAccount)
    }
  },
  mounted () {
    this.selectedAccount = this.currentRow.accounts.length ? this.currentRow.accounts[0] : null
  },
  computed: {
    selectService () {
      return JSON.parse(JSON.stringify(this.$store.getters['Tariffing/SERVICES'])).filter(value => {
        return value.parent_id === 0 &&
        value.tariff_id === 0 &&
        (value.service_name.toLowerCase().includes(this.filter) || value.service_type_name.toLowerCase().includes(this.filter)) &&
        (this.selectedServiceType === -1 || value.service_type === this.selectedServiceType)
      })
    },
    seviceLinks () {
      return this.$store.getters['Users/USER_SERVICES_LINKS_ACC']
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/serviceLinks/main.vue